import React from 'react';

export default () => (
  <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 2C13.95 2 18 5.222 18 9.2C18 13.178 13.95 16.4 9 16.4C7.884 16.4 6.813 16.238 5.823 15.95C3.195 18.2 0 18.2 0 18.2C2.097 16.103 2.43 14.69 2.475 14.15C0.945 12.863 0 11.117 0 9.2C0 5.222 4.05 2 9 2ZM8.1 11.9V13.7H9.9V11.9H8.1ZM8.1 10.1H9.9V4.7H8.1V10.1Z" fill="currentColor" />
  </svg>
);
